import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';
import { Button } from 'components/common/Button';
import { storageKeys } from 'config/app.config';
import { AuthHero } from 'components/auth/AuthHero';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await login(email, password);
      navigate(localStorage.getItem(storageKeys.pendingOnboarding) ? '/onboarding' : '/dashboard');
    } catch {
      setError('Invalid email or password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-start justify-start bg-[#f7f8f5] px-4 py-4 lg:items-center lg:justify-center lg:px-0 lg:py-0">
      <div className="grid w-full items-start gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(400px,0.85fr)] lg:items-center lg:gap-0">
        <AuthHero />
        <div className="w-full max-w-sm justify-self-center lg:mr-8">
        <div className="mb-8 text-center">
          <h1 className="text-3xl font-bold tracking-tight text-[#17231c]">Sign into your account</h1>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <h2 className="text-lg font-semibold text-gray-900 mb-5">Sign in</h2>

          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-md text-sm text-red-700">{error}</div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
              <input
                type="email" required value={email}
                onChange={e => setEmail(e.target.value)}
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
              <input
                type="password" required value={password}
                onChange={e => setPassword(e.target.value)}
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <Button type="submit" loading={loading} className="w-full justify-center">
              Sign in
            </Button>
          </form>

          <div className="mt-4 flex items-center justify-between text-xs text-gray-500">
            <Link to="/forgot-password" className="hover:text-blue-600">Forgot password?</Link>
            <Link to="/register" className="hover:text-blue-600">Create account</Link>
          </div>

        </div>
      </div>
        </div>
    </div>
  );
}

